import ServiceCenterChangeHistory from 'app/Apps/ContainerManagement/ServiceCenters/ServiceCenterChangeHistory'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useHasPermission from 'app/hooks/useHasPermission'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import {
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    ServiceCenterStatus,
} from 'app/enums/label.enums'
import {
    ServiceCenterTabs,
} from 'app/enums/domain.enums'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'

import tableConfig from './serviceCenters.config'
import ServiceCenterCreate from './ServiceCenterCreate'
import ServiceCenterOverview from './ServiceCenterOverview'
import ServiceCenterUpdate from './ServiceCenterUpdate'
import Monitoring from './Monitoring'
import ScenarioEditor from './ScenarioEditor'
import RelatedOrders from './RelatedOrders'
import WorkSchedule from './WorkSchedule'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const isSCActive = ({
    serviceCenterStatus,
    archived,
}) => {
    return serviceCenterStatus === ServiceCenterStatus.ACTIVE && !archived
}

const isNotArchived = ({
    archived,
}: {archived: boolean}) => {
    return !archived
}

const ServiceCenters = () => {
    const canCreate = useHasPermission(['service_center_create'])
    const canUpdate = useHasPermission(['service_center_update'])
    const canMonitoring = useHasPermission(['service_center_monitoring'])
    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                url: CommonRoutes.Overview,
                label: 'Overview',
                Component: ServiceCenterOverview,
            },
            permission: true,
        },
        {
            tab: {
                url: CommonRoutes.DataUpdate,
                label: 'Data Update',
                Component: ServiceCenterUpdate,
            },
            permission: canUpdate,
        },
        {
            tab: {
                url: ServiceCenterTabs.Monitoring,
                label: 'Monitoring',
                Component: Monitoring,
                condition: isSCActive,
            },
            permission: canMonitoring,
        },
        {
            tab: {
                url: ServiceCenterTabs.ScenarioEditor,
                label: 'Scenario Editor',
                Component: ScenarioEditor,
                condition: isSCActive,
            },
            permission: canMonitoring,
        },
        {
            tab: {
                url: ServiceCenterTabs.WorkSchedule,
                label: 'Work Schedule',
                Component: WorkSchedule,
            },
            permission: canUpdate,
        },
        {
            tab: {
                url: ServiceCenterTabs.RelatedOrders,
                label: 'Related Orders',
                Component: RelatedOrders,
                condition: isNotArchived,
            },
            permission: true,
        },
        {
            tab: {
                url: CommonRoutes.ChangeHistory,
                label: 'Change History',
                Component: ServiceCenterChangeHistory,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            defaultTab={CommonRoutes.Overview}
            name={tableConfig.name}
            getDomainObject={request.get}
            actionComponents={{
                Create: canCreate ? ServiceCenterCreate : undefined,
            }}
            sidebarTabs={tabs}
            domainRequestKey={RequestKeys.getServiceCenterById}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default ServiceCenters
